import { render, staticRenderFns } from "./PrinterForm.vue?vue&type=template&id=20cce5fc&"
import script from "./PrinterForm.vue?vue&type=script&lang=js&"
export * from "./PrinterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports